import { createAction } from '@reduxjs/toolkit';

const removePacket = createAction('removePacket');

export { removePacket };

export default {};
